import { Component } from "react";
import { connect } from "react-redux";
import NotesFilters from "../SiteMonitoringNotesFilters";
import List from "@mui/material/List";
import SiteMonitoringNote from "../SiteMonitoringNote";

class ReportTab extends Component {
    render() {
        let notes = [];

        this.props.filteredAndSortedNotes.forEach((n) => {
            notes.push(<SiteMonitoringNote key={n.mobile_id} previewMode note={n} />);
        });

        return (
            <div ref={this.props.pdfContainerRef}>
                <NotesFilters />
                <List className="row">{notes.map((d) => d)}</List>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        filteredAndSortedNotes: state.notes.filteredAndSortedNotes,
        siteMonitoring: state.siteMonitoring.currentSiteMonitoring,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportTab);
